import React, { Component } from "react";
import menuTheme from "css/themes/Menu.css";
import BrowserHistoryDispatcher from "dispatchers/browser-history-dispatcher";
import _ from "lodash";
import PropTypes from "prop-types";
import { IconMenu, MenuItem } from "react-toolbox/lib/menu";
import COLOURS from "util/colours";

const themes = {
  Menu: menuTheme,
};

export default class MyCampaignActions extends Component {
  render() {
    const { actions } = this.props;

    const extras = actions.splice(3);

    const icon = (
      <img
        src={"/images/util/more-icon-button.svg"}
        style={{
          marginTop: "-4px",
          marginLeft: "-8px",
        }}
      />
    );

    const actionsList = _.map(actions, (action, idx) => {
      return (
        <p
          key={idx}
          onClick={
            action.onClick ||
            function () {
              if (action.target == "_blank") {
                window.open(action.href);
              } else {
                BrowserHistoryDispatcher.push(action.href);
              }
            }
          }
          style={{
            fontFamily: "Larsseit-Medium",
            fontSize: "14px",
            lineHeight: "14px",
            color: COLOURS.azure,
            marginRight: "24px",
            cursor: "pointer",
          }}
        >
          {action.label}
        </p>
      );
    });

    const extrasList = _.map(extras, (action, idx) => {
      return (
        <MenuItem
          key={actionsList.length + idx}
          caption={action.label}
          onClick={
            action.onClick ||
            function () {
              BrowserHistoryDispatcher.push(action.href);
            }
          }
          theme={themes.Menu}
        />
      );
    });

    return (
      <div>
        <div
          style={{
            display: "inline-flex",
            marginTop: extrasList.length ? 0 : "9px",
            marginBottom: extrasList.length ? 0 : "7px",
          }}
        >
          {actionsList}
        </div>
        {extrasList.length ? (
          <div
            style={{
              display: "inline-flex",
            }}
          >
            <IconMenu
              icon={icon}
              position="topLeft"
              theme={themes.Menu}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {extrasList}
            </IconMenu>
          </div>
        ) : null}
      </div>
    );
  }
}

MyCampaignActions.propTypes = {
  actions: PropTypes.array.isRequired,
};
